/* eslint-disable camelcase,no-console */
import { TelemetryLocation } from "@teaming/common-enums";
import streamTelemetry from "./stream";

// eslint-disable-next-line no-unused-vars
export default ( { currentUser, amplitude, intercom, } ) => {
	return {
		...streamTelemetry( { currentUser, amplitude, intercom, } ),
		view1on1RelationshipList() {
			amplitude.event( "View 1:1 Relationship List Page", {} );
		},
		view1on1StreamTab( {
			teamId,
			teamName,
			isSampleTeam,
			otherMemberWorkStyleType,
			thisMemberWorkStyleType,
			thisMemberRole,
		} ) {
			amplitude.event( "View 1:1 Spaces Meetings Tab", {
				team_name: teamName,
			} );

			intercom.trackEvent( "1:1 Notes and Meetings Tab Viewed", {
				team_id: teamId,
				team_display_name: teamName,
				is_sample_one_on_one: isSampleTeam ? "TRUE" : "FALSE",
				other_member_ws_type: otherMemberWorkStyleType,
				this_member_ws_type: thisMemberWorkStyleType,
				this_member_role: thisMemberRole,
			} );
		},
		view1on1WorkStyleTab( { teamName, } ) {
			amplitude.event( "View 1:1 Spaces Work Style Tab", {
				team_name: teamName,
			} );
		},
		view1on1TeammateTab( { teamName, } ) {
			amplitude.event( "View 1:1 Spaces About Tab", {
				team_name: teamName,
			} );
		},
		view1on1CommitmentsTab( { teamName, } ) {
			amplitude.event( "View 1:1 Spaces Commitments Tab", {
				team_name: teamName,
			} );
		},
		view1on1GoalsTab( { teamName, } ) {
			amplitude.event( "View 1:1 Spaces Goals Tab", {
				team_name: teamName,
			} );
		},
		view1on1SettingsTab( { teamName, } ) {
			amplitude.event( "View 1:1 Spaces Settings Tab", {
				team_name: teamName,
			} );
		},
		view1on1ListArchivedPage() {
			amplitude.event( "View 1:1 Relationship List Archived Page", {} );
		},
		open1on1CreationDialog() {
			amplitude.event( "1:1 Creation Dialog Opened", {
				// NOTE: update when we allow this from additional locations
				creation_location: TelemetryLocation.ONE_ON_ONE_LIST,
			} );
		},
		create1on1Relationship( { teamName, } ) {
			amplitude.event( "1:1 Relationship Created", {
				team_name: teamName,
				// NOTE: update when we allow this from additional locations
				creation_location: TelemetryLocation.ONE_ON_ONE_LIST,
			} );
		},
		addSuggestedTopic( { categoryName, topicText, } ) {
			amplitude.event( "Suggested Topic Added", {
				category: categoryName,
				topic: topicText,
				// NOTE: update when we allow this from additional locations
				location: TelemetryLocation.ONE_ON_ONE_SPACES,
			} );
		},
		openSuggestedTopicPanel() {
			amplitude.event( "Suggested Topic Panel Opened", {
				// NOTE: update when we allow this from additional locations
				location: TelemetryLocation.ONE_ON_ONE_SPACES,
			} );
		},
		archive1on1( { teamName, } ) {
			amplitude.event( "1:1 Relationship Archived", {
				team_name: teamName,
			} );
		},
		unarchive1on1( { teamName, } ) {
			amplitude.event( "1:1 Relationship Unarchived", {
				team_name: teamName,
			} );
		},
		addMeetingTemplate( { templateTitle, } ) {
			amplitude.event( "Meeting Template Added", {
				template: templateTitle,
				location: TelemetryLocation.ONE_ON_ONE_SPACES,
			} );
		},
		addCustomTemplate( { template, } ) {
			amplitude.event( "Custom Template Added to Meeting", {
				location: TelemetryLocation.ONE_ON_ONE_SPACES,
				template,
			} );
		},
		createdCustomTemplate( { template, } ) {
			amplitude.event( "Custom Template Created", {
				location: TelemetryLocation.ONE_ON_ONE_SPACES,
				template,
			} );
		},
		deletedCustomTemplate( { template, } ) {
			amplitude.event( "Custom Template Deleted", {
				location: TelemetryLocation.ONE_ON_ONE_SPACES,
				template,
			} );
		},
	};
};
